<template lang="pug">
  div
    y-dialog(v-model="openSheet" max-width="600px" persistent scrollable)
      v-card(flat)
        v-card-title
          div.py-2
            .h6.basic800--text {{ $t('add_discount') }}
            .c1.primary400--text {{ $t('add_discount_text') }}
        v-divider.basic300
        v-card-text(style="color: rgba(0, 0, 0, 1);")
          v-form(ref="form")
            v-row.px-3.mt-6
              p.ma-0.label.basic600--text.text-uppercase {{ $t('discount_type') }}
            v-row.px-3.mb-4
              v-radio-group.mt-2(v-model='discountType' row dense)
                v-radio.mb-3(label='By amount', value='amount' style="width:100%")
                  template(v-slot:label)
                    div.p1.textColorDefault--text {{ $t('by_amount') }}
                v-radio.mb-3(label='By percentage', value='percentage' style="width:100%")
                  template(v-slot:label)
                    div.p1.textColorDefault--text {{ $t('by_percentage') }}
            
            v-row.px-3.mt-n6
              p.ma-0.label.basic600--text.text-uppercase(v-if="discountType == 'amount'") {{$t('price.label')}}
              p.ma-0.label.basic600--text.text-uppercase(v-if="discountType == 'percentage'" ) {{$t('percentage.label')}}
            v-row.px-3.mb-5.mt-2
              v-text-field(v-if="discountType == 'amount'" v-model='discount.amount' :placeholder="$t('price.placeholder')" dense outlined height="40" background-color="basic200" type="tel" :rules="rules.has_quantity" :prefix="$currency.symbol" @keypress="isNumber($event)")
              v-text-field(v-if="discountType == 'percentage'" v-model='discount.percentage' :placeholder="$t('percentage.placeholder')" dense outlined height="40" background-color="basic200" :rules="rules.discount_rate" type="tel" suffix="%" min=0 max=100 @keypress="isNumber($event)")
       
        v-card-actions
          v-spacer
          v-btn(color='white', text @click='openSheet = !openSheet')
            .button-Aa-medium.primary400--text {{ $t('cancel') }}
          v-btn.mr-2(color='info500' depressed @click="clickSave()")
            .button-AA-medium.basic100--text {{ $t('save') }}

</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'AddDiscount',
  props: {
    open: {
      type: Boolean,
      default: false
    },
    initialDiscount: {
      type: Object,
      default: null
    }
  },
  data: () => ({
    discount: {
      amount: null,
      percentage: null,
    },
    discountType: 'amount',
    rules: {
      has_quantity: [(v) => !!v || 'This field is required', (v) => v != 0|| 'This field is required'],
      discount_rate: [
        v => !!v || 'This field is required', 
        v => v >= 1 || 'Discount should not be below 1%',
        v => v <= 100 || 'Discount should not be above 100%',
      ]
    },
  }),
  computed: {
    openSheet: {
      get () {
        return this.open
      },
      set (newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  mounted () {
    if (this.initialDiscount) {
      if (this.initialDiscount.isPercentage) {
        this.discountType = 'percentage'
        this.discount.percentage = this.initialDiscount.value
      } else {
        this.discountType = 'amount'
        this.discount.amount = this.initialDiscount.value/this.$currency.multiplier
      }
    }
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    isNumber: function(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    clickSave() {
      if (!this.$refs.form.validate()) {
        return
      }
      const isPercentage = this.discountType === 'percentage'
      const amount = isPercentage ? (parseFloat(this.discount.percentage || 0)).toFixed(0) : (parseFloat(this.discount.amount || 0)).toFixed(this.$currency.exponent).replace('.', '')
      const data = {
        value: amount,
        isPercentage: isPercentage
      }
      this.$emit('added', data)
      this.openSheet = false
    }
  }
}
</script>

<style lang="scss" scoped>
.divbox {
  border: 2px solid var(--v-basic400);
  background-color: var(--v-basic200);
  height: 40px;
  max-width: 60px;
  border-radius: 5px;
}
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
</style>

<i18n>
{
  "en": {
    "price": {
      "label": "Discount",
      "placeholder": "0"
    },
    "percentage": {
      "label": "Discount",
      "placeholder": "1 - 100"
    },
    "add_discount_text": "Discount will be applied per quantity of product.",
    "discount_type": "Discount type",
    "by_amount": "By amount",
    "by_percentage": "By percentage"
  },
  "id": {
     "price": {
      "label": "Diskon",
      "placeholder": "0"
    },
    "percentage": {
      "label": "Diskon",
      "placeholder": "1 - 100"
    },
    "add_discount_text": "Diskon akan diterapkan per jumlah produk.",
    "discount_type": "Jenis Diskon",
    "by_amount": "Berdasarkan jumlah",
    "by_percentage": "Berdasarkan Persentase"
  }
}
</i18n>
